// pages/GalleryImageTraite.jsx
import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { BackLoadingSimple } from "../loading/backLoading";
import ImprimantSucces from "../../composant/message/imprimanteSucces";

import Impressions from "../../composant/impressions/impressions";
import { useImpressions } from "../../service/useImpressions";
import ImageCropDialog from "../EditImage";
import CategoryHashTags from "../hashtags/categoryHashtagsSelected";
import { ConfirmPrintPopup } from "../Popup/confirmationImpression";

export default function GalleryImageTraite({
  open,
  onClose,
  downloadImage,
  id,
}) {
  const images = useSelector((state) => state.commands?.PopupData?.images);
  const imprimant = useSelector(
    (state) => state.commands?.PopupData?.imprimant
  );

  // Use our custom hook – passing the images, command id, and imprimant
  const {
    allImages,
    selectedImages,
    openCropper,
    demonsion,
    src,
    loading,
    openPopup,
    handleSelectImage,
    handleSelectAll,
    editCountImage,
    sendToPrint,
    editImage,
    openImageCropper,
    setOpenCropper,
    setOpenPopup,
    selectedCategories,
    setSelectedCategories,
    sendNewhastags,
    PopupCat,
    setPopupCat,
    NumberImpression,
  } = useImpressions(images, id, imprimant);
  const [popupConfirm, setPopupConfirm] = useState(false);
  console.log("allImage", allImages);
  return (
    <>
      <Dialog open={open} fullScreen>
        <DialogTitle>
          <Typography variant="h4" textAlign="center" gutterBottom>
            Images Traitées
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Impressions
            allImages={allImages}
            selectedImages={selectedImages}
            handleSelectImage={handleSelectImage}
            downloadImage={downloadImage}
            openImageCropper={openImageCropper}
            editCountImage={editCountImage}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleSelectAll}>
            {selectedImages?.length === allImages?.length
              ? "Désélectionner Tout"
              : "Tout Sélectionner"}
          </Button>
          <Button variant="contained" onClick={() => setPopupCat(true)}>
            ajouter hashtags
          </Button>

          <Button
            color="error"
            variant="contained"
            onClick={() => {
              if (NumberImpression >= 1) {
                setPopupConfirm(true);
              } else {
                sendToPrint();
              }
            }}
          >
            Imprimer Images
          </Button>
          <Button onClick={onClose} variant="contained">
            Annulé
          </Button>
        </DialogActions>
      </Dialog>
      {/* Crop Dialog */}
      <ImageCropDialog
        open={openCropper}
        onClose={() => setOpenCropper(false)}
        src={src}
        demonsion={demonsion}
        onSubmit={editImage}
      />
      <CategoryHashTags
        open={PopupCat}
        onClose={() => setPopupCat(false)}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        sendNewhastags={sendNewhastags}
      />
      <ConfirmPrintPopup
        open={popupConfirm}
        onClose={() => setPopupConfirm(false)}
        onConfirm={() => {
          sendToPrint();
          setPopupConfirm(false);
        }}
      />
      <ImprimantSucces open={openPopup} onClose={() => setOpenPopup(false)} />
      <BackLoadingSimple open={loading} />
    </>
  );
}
